/**
 * Holiday registration visibility — mirrors pre-Sanity behavior:
 * - registrationOpen (CMS boolean) gates the block
 * - Shabbat / ready schedules: registration lives inside the schedule grid
 * - Schedule TBD + registrationOpen: side-by-side layout in HolidayModal
 */

export function isProspectiveShabbaton(holiday) {
  return Boolean(holiday?.id?.includes('shabbaton') || holiday?.whoCanAttend);
}

export function isRegistrationVisible(holiday) {
  return Boolean(holiday?.registration && holiday.registrationOpen);
}

export function isWeeklyShabbatSchedule(holiday) {
  const schedule = holiday?.schedule;
  return Boolean(schedule?.fridays && schedule?.saturdays);
}

export function isSubHolidaySchedule(holiday) {
  const schedule = holiday?.schedule;
  return Boolean(
    schedule?.roshHashanah ||
      schedule?.yomKippur ||
      schedule?.sukkot ||
      schedule?.simchatTorah
  );
}

/** Registration rendered inside schedule-container (Shabbat grid, ready sub-holidays, ready event lists). */
export function isRegistrationInScheduleGrid(holiday) {
  if (!isRegistrationVisible(holiday)) return false;
  if (isWeeklyShabbatSchedule(holiday)) return true;
  if (!holiday.scheduleReady) return false;
  return isSubHolidaySchedule(holiday) || Boolean(holiday.schedule?.events?.length);
}

/** Schedule TBD column beside registration (High Holidays, Passover, etc.). */
export function isSideBySideRegistration(holiday) {
  return isRegistrationVisible(holiday) && !isRegistrationInScheduleGrid(holiday);
}
